import { formatRelativeTime, escapeHtml } from '../utils/index.js';

class NoteItem extends HTMLElement {
  _note = null;
  _isSelected = false;
  _boundHandlers = {};

  static observedAttributes = ['selected'];

  constructor() {
    super();
  }

  set note(value) {
    this._note = value;
    this.render();
  }

  get note() {
    return this._note;
  }

  set selected(value) {
    this._isSelected = value;
    if (value) {
      this.setAttribute('selected', '');
    } else {
      this.removeAttribute('selected');
    }
    this.render();
  }

  get selected() {
    return this._isSelected;
  }

  connectedCallback() {
    this.render();
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  _removeEventListeners() {
    const item = this.querySelector('.note-item-container');
    const archiveBtn = this.querySelector('.note-item-archive-btn');

    if (item && this._boundHandlers.itemClick) {
      item.removeEventListener('click', this._boundHandlers.itemClick);
    }
    if (archiveBtn && this._boundHandlers.archiveClick) {
      archiveBtn.removeEventListener('click', this._boundHandlers.archiveClick);
    }
  }

  _attachEventListeners() {
    const item = this.querySelector('.note-item-container');
    const archiveBtn = this.querySelector('.note-item-archive-btn');

    this._boundHandlers.itemClick = (e) => {
      if (e.target.closest('.note-item-action-btn')) return;
      this.dispatchEvent(
        new CustomEvent('note-selected', {
          detail: { note: this._note },
          bubbles: true,
        })
      );
    };

    this._boundHandlers.archiveClick = (e) => {
      e.stopPropagation();
      const eventName = this._note.archived ? 'note-unarchived' : 'note-archived';
      this.dispatchEvent(
        new CustomEvent(eventName, {
          detail: { id: this._note.id },
          bubbles: true,
        })
      );
    };

    item?.addEventListener('click', this._boundHandlers.itemClick);
    archiveBtn?.addEventListener('click', this._boundHandlers.archiveClick);
  }

  render() {
    if (!this._note) return;

    this._removeEventListeners();

    const selectedClass = this._isSelected ? 'selected' : '';
    const archiveIcon = this._note.archived ? 'unarchive' : 'archive';
    const archiveTitle = this._note.archived ? 'Unarchive' : 'Archive';
    const escapedTitle = escapeHtml(this._note.title);
    const escapedBody = escapeHtml(this._note.body);
    const formattedDate = formatRelativeTime(this._note.createdAt);

    this.innerHTML = `
      <article class="note-item-container ${selectedClass}">
        <div class="note-item-header">
          <h3 class="note-item-title">${escapedTitle}</h3>
          <div class="note-item-actions">
            <button class="note-item-action-btn note-item-archive-btn" title="${archiveTitle}" aria-label="${archiveTitle} note">
              <span class="material-symbols-outlined">${archiveIcon}</span>
            </button>
          </div>
          <span class="note-item-date">${formattedDate}</span>
        </div>
        <p class="note-item-body">${escapedBody}</p>
      </article>
    `;

    this._attachEventListeners();
  }
}

customElements.define('note-item', NoteItem);
